<template>
    <div class="fabu-success-page">
        <!-- 头部组件 -->
        <Header />

        <div class="content-wrapper">
            <!-- 面包屑导航 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ name: 'home' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>发布成功</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <!-- 发布成功内容区域 -->
            <div class="success-content">
                <div class="success-icon-container">
                    <div class="">
                        <img src="../../assets/images/33.png" alt="" style="width: 88px;height: 64px;">
                    </div>
                </div>
                <div class="success-message">采购单发布成功！</div>
                <div class="action-buttons">
                    <el-button class="back-home-button" @click="goBackHome">返回首页</el-button>
                </div>
            </div>
        </div>

        <!-- 底部组件 -->
        <Footer />
    </div>
</template>

<script>
// 导入头部和底部组件
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'

export default {
    name: 'FabuSuccessPage',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            // 页面数据
        }
    },
    methods: {
        // 返回首页
        goBackHome() {
            this.$router.push('/')
        }
    }
}
</script>

<style scoped>
.fabu-success-page {
    min-height: 100vh;
    background-color: #f5f7fa;
}

.content-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.breadcrumb {
    padding: 24px 0 20px 0;
}

/* 发布成功内容区域样式 */
.success-content {
    background-color: #fff;
    /* padding: 60px 40px; */
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    text-align: center;
    margin: 0 auto;
    max-width: 100%;
    height: 480px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.success-icon-container {
    margin-bottom: 30px;
}

.success-icon {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    border-radius: 50%;
    background-color: #f0f9eb;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 60px;
    color: #67c23a;
}

.success-message {
    font-weight: 400;
    font-size: 18px;
    color: #221E1F;
    margin-bottom: 40px;
}

.action-buttons {
    display: flex;
    justify-content: center;
}

.back-home-button {
    width: 180px;
    height: 48px;
    font-size: 16px;
}
</style>